import { IconButton } from "@dropbox/dig-components/buttons";
import { Text, Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/assets";
import { DigTooltip } from "@mirage/shared/util/DigTooltip";
import i18n from "@mirage/translations";
import styles from "./GlobalNavAppsIconTooltip.module.css";
import { useAppsTooltip } from "./useAppsTooltip";

type Props = {
  triggerRef: React.RefObject<HTMLElement | Element>;
};

export function GlobalNavAppsIconTooltip({ triggerRef }: Props) {
  const { isTooltipOpen, setDismissed: setTooltipDismissed } = useAppsTooltip();

  const handleDismiss = () => {
    setTooltipDismissed(true);
  };

  return (
    <DigTooltip.Control
      variant="rich"
      open={isTooltipOpen}
      triggerRef={triggerRef}
      auto
      placement="right"
      maxWidth={300}
    >
      <IconButton
        variant="borderless"
        onClick={handleDismiss}
        className={styles.dismissButton}
        aria-label={i18n.t("close")}
      >
        <UIIcon src={CloseLine} />
      </IconButton>
      <Box className={styles.tourTooltip}>
        <Title size="small" weightVariant="emphasized">
          {i18n.t("add_apps_tooltip_title")}
        </Title>
        <Text tagName="p">{i18n.t("add_apps_tooltip_subtitle")}</Text>
      </Box>
    </DigTooltip.Control>
  );
}
